/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentProbabilities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Probability API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, January 21, 2019 - 03:55:55 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Probabilities = {
    all: () => requests.get('/Probabilities'),
    get: probabilityid => requests.get(`/Probability/${probabilityid}`),
    create: probability => requests.post(`/Probabilities`, probability),
    update: (probabilityid, probability) => requests.put(`/Probability/${probabilityid}`, probability),
    delete: probabilityid => requests.del(`/Probability/${probabilityid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentProbabilities.js